import * as React from 'react';

import { Heading } from '../../../../../../../../components';
import iconError from '../../../../../../../../../assets/illustrations/error-files.svg';
import {
  BlockPhoto,
  ButtonContainerWrongPeriod,
  ButtonRequest,
  CommonBlock
} from './styled';

interface WrongPeriodProps {
  handleClose: () => void;
}
const WrongPeriod: React.FC<WrongPeriodProps> = (props) => {
  const { handleClose } = props;
  return (
    <CommonBlock>
      <BlockPhoto>
        <img src={iconError} alt="error" />
      </BlockPhoto>
      <Heading
        text="Debes estar matriculado en el ciclo actual para realizar este trámite."
        level={2}
        color="#161D1F"
        size={20}
        lineHeight={32}
        fontWeight="900"
        className=""
        align="center"
        width="100%"
      />
      <ButtonContainerWrongPeriod>
        <ButtonRequest onClick={() => handleClose()}>
          <p>Entendido</p>
        </ButtonRequest>
      </ButtonContainerWrongPeriod>
    </CommonBlock>
  );
};

export default WrongPeriod;
